import { print } from 'graphql';

import {
  GetCustomSpecialtyBrandingDocument,
  GetJobReportBrandingDocument,
  GetReportQuoteIssuesDocument,
  GetBookmarkListDocument,
  GetBookmarkListsDocument,
  GetBookmarksDocument,
  GetMomentsDocument,
  GetMomentBookmarksDocument,
  GetUploadUrlDocument,
  GetJobDocument,
  GetSpeakersDocument,
  GetJobPermissionsDocument,
  GetJobsDocument,
  GetJobs_CheckTransientsDocument,
  GetJobRelatedBookmarksDocument,
  GetJobBookmarksDocument,
  GetTeamDocument,
  GetTeamMembersDocument,
  GetTeamInvitationsDocument,
  GetTeamsDocument,
  GetProfileDocument,
  AdminGetJobsDocument,
  SearchMomentsDocument,
  GetSpeakerDocument,
  BatchGetSpeakersDocument,
  GetTracksDocument,
  AdminGetProfileDocument,
  GetCommentsDocument,
  ViewerDocument,
  GetExternalLibraryDocument,
  GetReactionsDocument,
  GetJob_CheckLiveStatusDocument,
  GetTeam_CheckPermissionsDocument,
  KeenQueryDocument,
  KeenBatchDocument,
  Keen_GetTopicViewsDocument,
  Keen_GetSubTopicViewsDocument,
  Keen_GetMostBookmarkedTopicsDocument,
  Keen_GetMostBookmarkedSubtopicsDocument,
  Keen_GetReactionsDocument,
  Keen_GetBookmarksDocument,
  Keen_GetTeamUserUploadsDocument,
  Keen_GetTeamUserEditsDocument,
  Keen_GetTeamUserBookmarksDocument,
  Keen_GetTeamUserReactionsDocument,
  Keen_GetHoursCliprdProcessedDocument,
  Keen_GetHoursCliprdViewedDocument,
  Keen_GetHoursCliprdSavedDocument,
  Keen_GetVideoAddToTeamDocument,
  Keen_GetPlaysDocument,
  Keen_GetVideoSharesDocument,
  Keen_GetTotalDailyReactionsDocument,
  Keen_GetReactionsByJobSourceDocument,
  Keen_GetPerformanceDocument,
  Keen_GetTotalUniqueUploadsDocument,
  Keen_GetTotalPlaysDocument,
  Keen_GetTotalTopicsDocument,
  Keen_GetTotalReactionsDocument,
  Keen_GetTotalSharesDocument,
  Keen_GetTotalBookmarksDocument,
  Keen_GetAvgWatchTimeDocument,
  GetNotificationSubscriptionEmailEventTypesDocument,
  UploadWidget_GetTeamDocument,
  GetMomentDocument,
  GetJobTranscriptDocument,
  GetTeamTagsDocument,
  GetTeam_GetAdsDocument,
  GetTeamNamespacesDocument,
  GetJob_CheckPermissionsDocument,
  GetJob_CheckDualPlusStatusDocument,
  GetJob_CheckReportRevisingDocument,
  GetDownloadLinkDocument,
  GetTranslatedDocumentDocument,
  GetOriginalDocumentDocument,
  GetJobReportDiffDocument,
  GetAgencyTemplateByDomainDocument,
  GetAgencyOfficerStatsDocument,
  RetrieveDeceptioAiAnalysisDocument,
  AdminListAgenciesDocument,
  AdminListAgenciesWithoutLibrariesDocument,
  AdminGetAgencyDocument,
  ShareableAssetsDocument,
} from '@clipr/lib';

export const ApiQueryDocuments = {
  getCustomSpecialtyBranding: GetCustomSpecialtyBrandingDocument,
  getJobReportBranding: GetJobReportBrandingDocument,
  getReportQuoteIssues: GetReportQuoteIssuesDocument,
  getBookmarks: GetBookmarksDocument,
  getBookmarkLists: GetBookmarkListsDocument,
  getBookmarkList: GetBookmarkListDocument,
  getMoments: GetMomentsDocument,
  getMoment: GetMomentDocument,
  getMomentBookmarks: GetMomentBookmarksDocument,
  getJobBookmarks: GetJobBookmarksDocument,
  getJobRelatedBookmarks: GetJobRelatedBookmarksDocument,
  getUploadUrl: GetUploadUrlDocument,
  getJob: GetJobDocument,
  getJobPermissions: GetJobPermissionsDocument,
  getJobs: GetJobsDocument,
  getJobs_checkTransients: GetJobs_CheckTransientsDocument,
  getSpeakers: GetSpeakersDocument,
  getSpeaker: GetSpeakerDocument,
  batchGetSpeakers: BatchGetSpeakersDocument,
  getTracks: GetTracksDocument,
  getTeam: GetTeamDocument,
  getTeam_getAds: GetTeam_GetAdsDocument,
  getTeamMembers: GetTeamMembersDocument,
  getTeamInvitations: GetTeamInvitationsDocument,
  getTeamNamespaces: GetTeamNamespacesDocument,
  getTeamTags: GetTeamTagsDocument,
  getTeams: GetTeamsDocument,
  getProfile: GetProfileDocument,
  getNotificationSubscriptionEmailEventTypes: GetNotificationSubscriptionEmailEventTypesDocument,
  adminGetJobs: AdminGetJobsDocument,
  searchMoments: SearchMomentsDocument,
  adminGetProfile: AdminGetProfileDocument,
  getComments: GetCommentsDocument,
  getReactions: GetReactionsDocument,
  viewer: ViewerDocument,
  getExternalLibrary: GetExternalLibraryDocument,
  getJob_checkLiveStatus: GetJob_CheckLiveStatusDocument,
  getJob_checkPermissions: GetJob_CheckPermissionsDocument,
  getJob_checkDualPlusStatus: GetJob_CheckDualPlusStatusDocument,
  getJob_checkReportRevising: GetJob_CheckReportRevisingDocument,
  getTeam_checkPermissions: GetTeam_CheckPermissionsDocument,
  keenQuery: KeenQueryDocument,
  keenBatch: KeenBatchDocument,
  keen_getTopicViews: Keen_GetTopicViewsDocument,
  keen_getSubTopicViews: Keen_GetSubTopicViewsDocument,
  keen_getMostBookmarkedTopics: Keen_GetMostBookmarkedTopicsDocument,
  keen_getMostBookmarkedSubtopics: Keen_GetMostBookmarkedSubtopicsDocument,
  keen_getReactions: Keen_GetReactionsDocument,
  keen_getBookmarks: Keen_GetBookmarksDocument,
  keen_getTeamUserUploads: Keen_GetTeamUserUploadsDocument,
  keen_getTeamUserEdits: Keen_GetTeamUserEditsDocument,
  keen_getTeamUserBookmarks: Keen_GetTeamUserBookmarksDocument,
  keen_getTeamUserReactions: Keen_GetTeamUserReactionsDocument,
  keen_getHoursCliprdProcessed: Keen_GetHoursCliprdProcessedDocument,
  keen_getHoursCliprdViewed: Keen_GetHoursCliprdViewedDocument,
  keen_getHoursCliprdSaved: Keen_GetHoursCliprdSavedDocument,
  keen_getVideoAddToTeam: Keen_GetVideoAddToTeamDocument,
  keen_getPlays: Keen_GetPlaysDocument,
  keen_getVideoShares: Keen_GetVideoSharesDocument,
  keen_getTotalDailyReactions: Keen_GetTotalDailyReactionsDocument,
  keen_getReactionsByJobSource: Keen_GetReactionsByJobSourceDocument,
  keen_getPerformance: Keen_GetPerformanceDocument,
  keen_getTotalUniqueUploads: Keen_GetTotalUniqueUploadsDocument,
  keen_getTotalPlays: Keen_GetTotalPlaysDocument,
  keen_getTotalTopics: Keen_GetTotalTopicsDocument,
  keen_getTotalReactions: Keen_GetTotalReactionsDocument,
  keen_getTotalShares: Keen_GetTotalSharesDocument,
  keen_getTotalBookmarks: Keen_GetTotalBookmarksDocument,
  keen_getAvgWatchTime: Keen_GetAvgWatchTimeDocument,
  uploadWidget_getTeam: UploadWidget_GetTeamDocument,
  getJobTranscript: GetJobTranscriptDocument,
  getDownloadLink: GetDownloadLinkDocument,
  getTranslatedDocument: GetTranslatedDocumentDocument,
  getOriginalDocument: GetOriginalDocumentDocument,
  getJobReportDiff: GetJobReportDiffDocument,
  retrieveDeceptioAiAnalysis: RetrieveDeceptioAiAnalysisDocument,
  getAgencyTemplateByDomain: GetAgencyTemplateByDomainDocument,
  getAgencyOfficerStats: GetAgencyOfficerStatsDocument,
  adminListAgencies: AdminListAgenciesDocument,
  adminListAgenciesWithoutLibraries: AdminListAgenciesWithoutLibrariesDocument,
  adminGetAgency: AdminGetAgencyDocument,
  shareableAssets: ShareableAssetsDocument,
} as const;

export const ApiQueries: { [key in keyof typeof ApiQueryDocuments]: string } = Object.fromEntries(
  Object.entries(ApiQueryDocuments).map(([name, doc]) => [name, print(doc)]),
) as { [key in keyof typeof ApiQueryDocuments]: string };
